var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.599976 14.4048V15.6C0.599976 16.5548 0.97926 17.4704 1.65439 18.1456C2.32952 18.8207 3.2452 19.2 4.19998 19.2H16.2C17.1548 19.2 18.0704 18.8207 18.7456 18.1456C19.4207 17.4704 19.8 16.5548 19.8 15.6V14.4M10.2 0.599976V13.8M5.99998 9.59998L10.2 13.8L14.4 9.59998",
    stroke: "#0D1139",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartDownload);
export default __webpack_public_path__ + "static/media/chart-download.1842e0fa.svg";
export { ForwardRef as ReactComponent };